<template>
  <v-container>
    <v-card flat class="mb-3">
      <v-toolbar dark dense flat>
        <v-icon>mdi-view-dashboard-variant</v-icon> <span class="ml-2 ellipsify">Dashboard</span>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <ProjectDashboard/>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ProjectDashboard from "@/components/ProjectDashboard";

export default {
  components: {
    ProjectDashboard
  },
  data() {
    return {
      tab: null
    }
  }
}
</script>

<style>

</style>